import Axios from 'axios'
Axios.defaults.withCredentials = true // Allow Axios cross with cookie
export default {
  getActivityInfo ({commit, state}, preLoad) {
    return new Promise((resolve, reject) => {
      Axios.get(state.baseUrl + '/restful/v1/activities/' + preLoad.activityId + '/' + preLoad.applyId).then((res) => {
        if (res.data.code === 0) {
          commit('activityInfo', res.data.data.activityInfo)
          commit('promotionList', res.data.data.promotionList)
          commit('couponList', res.data.data.couponList)
          commit('applyGiftMaterialList', res.data.data.applyGiftMaterialList)
          commit('contentVenderLabelList', res.data.data.contentVenderLabelList)
          commit('productList', res.data.data.productList)
          commit('beltList', res.data.data.beltList)
          resolve()
        }
      })
    })
  },
  loadUserInfo ({commit, state}) {
    return new Promise((resolve, reject) => {
      Axios.get(state.baseUrl + '/restful/v1/users/current').then(res => {
        if (res.data.code === 0) {
          commit('userInfo', res.data.data)
          resolve(res.data.data)
        }
      })
    })
  },
  setLangFlag: (context) => {
    context.commit('setLangFlag')
  }
}



// WEBPACK FOOTER //
// ./src/store/action.js